import React from "react";
import { Link } from "react-router-dom";
import { EquipementData } from "../../../../api/EquipementData";
import SectionTitle from "../../../Shared/SectionTitle";

const Category = () => {
  return (
    <div className="wpo-project-area-s2 section-padding">
      <div className="container">
        <SectionTitle MainTitle={"GEHL"} subTitle={"Nos machines"} />
        <div className="row align-items-center">
          <div className="wpo-project-wrap">
            <div className="sortable-gallery">
              <div className="row">
                <div className="col-lg-12">
                  <div className="project-grids gallery-container clearfix">
                    {EquipementData.map((equipment) => (
                      <div className="grid" key={equipment.id}>
                        <Link to={`/equipement/single/${equipment.id}`}>
                          <div className="wpo-project-item">
                            <div className="wpo-project-img">
                              <img src={equipment.image} alt="" />
                              <div className="left-border"></div>
                              <div className="right-border"></div>
                            </div>
                            <div className="wpo-project-text category-title">
                              <h2>{equipment.title}</h2>
                              {/* <span>{equipment.subTitle}</span> */}
                            </div>
                          </div>
                        </Link>
                        <h3 className="subTitle-category">{equipment.title}</h3>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Category;
